// VUE
import Vue from 'vue';

// ROUTER
import VueRouter from 'vue-router';
import router from './router';
Vue.use(VueRouter);

// META
import Meta from 'vue-meta';
Vue.use(Meta);

// STORE
import store from './store.js';

// TRACKING RRWEB
import { record } from 'rrweb';
if(process.env.NODE_ENV==='production'){
	record({
		emit(event) {
			store.commit('rrweb', event);
		},
	});
}

// SOCKET
import VueSocketIOExt from 'vue-socket.io-extended';
import io from 'socket.io-client';
const socket = io(process.env.VUE_APP_SOCKET_IO_SERVER);
Vue.use(VueSocketIOExt, socket);

// COMPONENTS
import DownloadBtn from "./views/download-btn.vue";
import Foot from './views/footer.vue';
import Top from "./views/top.vue";
import Navh from "./views/navh.vue";
import Forme from "./components/forme.vue";
import Pic from "./components/pic.vue";
Vue.component('DownloadBtn', DownloadBtn);
Vue.component('Foot', Foot);
Vue.component('Top', Top);
Vue.component('Navh', Navh);
Vue.component('Forme', Forme);
Vue.component('Pic', Pic);

// COMPONENTS
const Montant = () => import(/*webpackChunkName:"format"*/ './components/format-montant.vue');
const Date = () => import(/*webpackChunkName:"format"*/ './components/format-date.vue');
Vue.component('montant', Montant);
Vue.component('date', Date);

// Form
const VueForm = () => import(/*webpackChunkName:"form" webpackPreload:true*/ './components/form/Form.vue');
const VueField = () => import(/*webpackChunkName:"form" webpackPreload:true*/ './components/form/FormField.vue');
const VueInput = () => import(/*webpackChunkName:"form"*/ './components/form/vue-input.vue');
const VueTextarea = () => import(/*webpackChunkName:"form"*/ './components/form/vue-input-textarea.vue');
const VueAdresse = () => import(/*webpackChunkName:"form"*/ './components/form/vue-input-adresse.vue');
Vue.component('VueForm', VueForm);
Vue.component('VueInput', VueInput);
Vue.component('VueInputText', VueInput);
Vue.component('VueInputTel', VueInput);
Vue.component('VueInputEmail', VueInput);
Vue.component('VueInputPassword', VueInput);
Vue.component('VueInputTextarea', VueTextarea);
Vue.component('VueInputAdresse', VueAdresse);
Vue.component('VueInputNumber', VueInput);
Vue.component('VueField', VueField);


// FILTERS
Vue.filter('ucfirst', function (string) {
	if (!string) return '';
	string = string.toString();
	return string.charAt(0).toUpperCase() + string.slice(1);
});

// MIXIN
Vue.mixin({
	computed: {
		env: function () {
			return process.env;
		},
	},
	data: function() {
		return {
			scroll:{
				y: 0,
				h: 0,
				devis: 1000,
				dh: null,
				top: null,
			}
		}
	},
	methods: {
		handleScroll () {
			this.scroll.y = window.scrollY;
			this.scroll.h = window.innerHeight;
			let devisDom = document.getElementById('devis');
			if(devisDom){
				this.scroll.devis = devisDom.offsetTop;
				this.scroll.dh = devisDom.offsetHeight;
			}
			let topDom = document.getElementById('top');
			if(topDom){
				this.scroll.top = topDom.offsetHeight;
			}
		}
	},
	created () {
		window.addEventListener('wheel', this.handleScroll);
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed () {
		window.removeEventListener('wheel', this.handleScroll);
		window.removeEventListener('scroll', this.handleScroll);
	}
});

// GOOGLE ANALYTICS - GTAG
import VueGtag from "vue-gtag";
if(process.env.NODE_ENV==='production'){
	Vue.use(VueGtag, {
		config: { id: "G-165Y9NXB31" }
	}, router);
	Vue.mixin({
		methods: {
			gtag(action, category, label) {
				this.$gtag.event(action, {
					event_category: category ? category : null,
					event_label: label ? label : null,
					// value: value
				});
			}
		}
	});
}else{
	Vue.mixin({
		methods: {
			gtag(action, category, label) {
				return null;
			}
		}
	});
}
import App from './app.vue';
import './service-worker/registerServiceWorker.js'


// import vue-panzoom
import panZoom from 'vue-panzoom'
// Vue.use(PanZoom);
Vue.use(panZoom, {componentName: 'panzoom'});

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
